import { segurancaModel } from './index.model'; 
 

export const permissaoService = {
	getPermissao,
	getUrl,  
};


const url = segurancaModel.getUrl() + '/permissao' ;  



function getUrl(  ) { 
	return window.http_api.defaults.baseURL + url; 
}



function getPermissao( id  ) { 
	return  new Promise((resolve, reject) => {
		window.http_api.get( url + '/' + id    )
		.then(response => {    
			resolve( response.data);  
		})
		.catch(error => {  
			reject(error.response);
		}) 
	}); 
}
  